import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import {
  createAccountCCEmail,
  getAccountCCEmails,
  removeAccountCCEmail,
} from '../../actions/superadmin';
import { storeWithExpiration } from '../../utils/common';
import { VALID_EMAIL_REGEX } from '../../config/app_config';

import ManageEmailsForm from './ManageEmailsForm';

const FORM_ID = 'ccEmailsForm';

export class ManageEmailsContainer extends React.Component {
  static propTypes = {
    accountId: PropTypes.number.isRequired,
    accountCCEmails: PropTypes.object.isRequired,
    cancelFunction: PropTypes.func.isRequired,
    createAccountCCEmailAction: PropTypes.func.isRequired,
    getAccountCCEmailsAction: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    removeAccountCCEmailAction: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
  };

  componentWillMount = () => {
    const { getAccountCCEmailsAction, accountId } = this.props;
    const token = storeWithExpiration.get('token');
    getAccountCCEmailsAction(accountId, token);
  };

  createAccountCCEmailFunction = params => {
    const { createAccountCCEmailAction, accountId, reset } = this.props;
    const token = storeWithExpiration.get('token');
    const { email } = params;
    createAccountCCEmailAction(accountId, email, token);
    reset();
  };

  removeAccountCCEmailFunction = emailId => {
    const { removeAccountCCEmailAction, accountId } = this.props;
    const token = storeWithExpiration.get('token');
    removeAccountCCEmailAction(accountId, emailId, token);
  };

  render() {
    const {
      accountId,
      accountCCEmails,
      cancelFunction,
      handleSubmit,
      invalid,
      pristine,
      submitting,
    } = this.props;

    return (
      <ManageEmailsForm
        accountId={accountId}
        accountCCEmails={accountCCEmails}
        cancelFunction={cancelFunction}
        createAccountCCEmailFunction={this.createAccountCCEmailFunction}
        handleSubmit={handleSubmit}
        invalid={invalid}
        pristine={pristine}
        removeAccountCCEmailFunction={this.removeAccountCCEmailFunction}
        submitting={submitting}
      />
    );
  }
}

const mapStateToProps = state => {
  const { superadmin } = state;
  const accountCCEmails = superadmin.get('accountCCEmails');
  return { accountCCEmails };
};

const validate = (values, props) => {
  const errors = {};
  const { accountCCEmails } = props;
  const alreadyAdded = accountCCEmails.find(e => e.email === values.email);

  if (!values.email || values.email === '') {
    errors.email = 'Required';
  } else if (!VALID_EMAIL_REGEX.test(values.email)) {
    errors.email = 'Invalid email address';
  } else if (alreadyAdded !== undefined) {
    errors.email = 'Email address already added';
  }
  return errors;
};

const ManageEmailsContainerRF = reduxForm({
  form: FORM_ID,
  validate,
  enableReinitialize: true,
})(ManageEmailsContainer);

export default connect(mapStateToProps, {
  createAccountCCEmailAction: createAccountCCEmail,
  getAccountCCEmailsAction: getAccountCCEmails,
  removeAccountCCEmailAction: removeAccountCCEmail,
})(ManageEmailsContainerRF);
